export const EnergySources = [
  {
    value: 'Gasolina',
    label: 'Gasolina',
  },
  {
    value: 'Petróleo',
    label: 'Petróleo',
  },
  {
    value: 'Eléctrico',
    label: 'Eléctrico',
  },
];
